import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { requirements } from '../../docs-routes'

const Requirements = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Requirements
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            The Requirements page is where you can import your test requirements and track their status. When you add requirements to individual test case steps and then run the test cases in Live Run or in a Test Config, DAI updates your requirement status based on the results of those tests.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={requirements}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default Requirements
